import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import HeaderNav from 'components/molecules/HeaderNav';
import { getTodayDayOfMonth } from 'helper/date';
import { actionCreators as eventsAC } from 'store/events';
import { getHeaderNavLinks } from 'store/view';

const mapStateToProps = (state) => {
	const internalPropsMap = {
		links: getHeaderNavLinks(state),
		todayDayOfMonth: getTodayDayOfMonth(),
	};

	const linksSignatureList = internalPropsMap.links.map((link: any, index: any) => {
		return `${index}/${link.additions ? link.additions.length : 0}/${link.selected}/${link.href}`;
	});

	return {
		...internalPropsMap,
		linksSignature: `${internalPropsMap.links.length}-${linksSignatureList.join('-')}`,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...eventsAC }, dispatch);
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default (connector as any)(withRouter(HeaderNav as any));
